import { EmojiWithBackground } from '$tablet-app/src/app/components/EmojiWithBackground/EmojiWithBackground';
import { ProfileIcons } from '$tablet-app/src/app/components/ProfileIcons/ProfileIcons';
import Shadow from '$tablet-app/src/app/components/Shadow';
import { Text } from '$tablet-app/src/app/components/Text/Text';
import { MealImage } from '$tablet-app/src/app/meals/components/MealImage';
import { palette } from '$tablet-app/src/app/theme';
import { timeAMPM } from '$tablet-app/src/app/utils/dateTime';
import { getStartDate } from '@akin-home/calendar';
import {
  CalendarItemUnion,
  getCalendarItemBackgroundColor,
} from '@akin-home/calendar/combined';
import { useHabitatID } from '@akin-home/habitats/react';
import { isMeal } from '@akin-home/meals';
import { useListAllUsersByHabitat } from '@akin-home/users/react';
import React, { FC, useMemo } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import styled from 'styled-components/native';

interface Props {
  item: CalendarItemUnion;

  onPress?: (item: CalendarItemUnion) => void;

  style?: StyleProp<ViewStyle>;
}

const CalendarItemCard: FC<Props> = (props) => {
  const { item, style, onPress } = props;

  const { title, emoji } = item;

  const habitatID = useHabitatID();

  const { data: users } = useListAllUsersByHabitat({ habitatID });

  const handlePress = () => onPress?.(props.item);
  const backgroundColor = getCalendarItemBackgroundColor(props.item);

  const participantIDs =
    item.type === 'Event' ? item.participantIDs : undefined;

  const participants = useMemo(
    () =>
      item.type === 'Event'
        ? users?.filter((u) => participantIDs?.includes(u.id))
        : undefined,
    [users, participantIDs, item.type]
  );

  return (
    <Tile style={[{ backgroundColor }, style]}>
      <Container onPress={handlePress}>
        {isMeal(item) ? (
          <StyledMealImage meal={item} />
        ) : emoji ? (
          <Emoji emojiStyle={styles.emoji} emoji={emoji} />
        ) : null}

        <TileTextContent>
          <Title weight="semibold" numberOfLines={1}>
            {title}
          </Title>
          <Text>{timeAMPM(getStartDate(props.item), true)}</Text>
        </TileTextContent>

        {participants ? (
          <ProfileIcons profiles={participants} preset="overlapRight" />
        ) : (
          <View />
        )}
      </Container>
    </Tile>
  );
};

const Tile = styled(Shadow)`
  border: 4px solid ${palette.white};
  border-radius: 10px;
`;

const Container = styled.TouchableOpacity`
  padding: 12px;
  flex-grow: 1;
  flex-direction: row;
  gap: 20px;
`;

const Emoji = styled(EmojiWithBackground)`
  margin-top: 4px;
  height: 48px;
  width: 48px;
`;

const Title = styled(Text)`
  overflow: hidden;

  font-size: 20px;
`;

const TileTextContent = styled.View`
  flex: 1;
`;

const StyledMealImage = styled(MealImage)`
  height: 48px;
  width: 48px;

  border-radius: 15px;
`;

const styles = StyleSheet.create({
  emoji: {
    fontSize: 20,
  },
});

export default CalendarItemCard;
